import axios from 'axios';

export const getTaskOutcomeList = async () => {
    const { data } = await axios.get('/app/taskFunnel/taskOutcome/list');

    return data;
};

export const getTaskOutcomeCategoryList = async () => {
    const { data } = await axios.get('/app/taskFunnel/taskOutcomeCategory/list');

    return data;
};

export const deleteOutcome = async (outcomeID) => {
    await axios.post(`/app/taskFunnel/deleteOutcome/${outcomeID}`);
};

export const deleteCategory = async (categoryID) => {
    await axios.post(`/app/taskFunnel/deleteCategory/${categoryID}`);
};

export const updateOutcome = async (taskOutcomePayload) => {
    const { data } = await axios.put(`/app/taskFunnel/taskOutcome/${taskOutcomePayload.id}`, taskOutcomePayload);

    return data;
};

export const addOutcome = async (taskOutcomePayload) => {
    const { data } = await axios.post('/app/taskFunnel/taskOutcome', taskOutcomePayload);

    return data;
};

export const updateCategory = async (taskOutcomeCategoryPayload) => {
    const { data } = await axios.put(`/app/taskFunnel/taskOutcomeCategory/${taskOutcomeCategoryPayload.id}`, taskOutcomeCategoryPayload);

    return data;
};

export const addCategory = async (taskOutcomeCategoryPayload) => {
    const { data } = await axios.post('/app/taskFunnel/taskOutcomeCategory', taskOutcomeCategoryPayload);

    return data;
};
